import { Field } from "@smartsoftware/reflex-core";
import { DexResourceModel } from "../abstracts/dexResource.model";


export class SuccessAccountNotifications extends DexResourceModel
{

    @Field(String)
    public successAccount_uuid: string = "";

    @Field(String)
    public notificationType_uuid: string = "";

    @Field(Boolean)
    public isDisabled: boolean = false;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }
}